// T22.688 (Kelly 2026-10-28): a broken Image / Video / Audio block inside a
// segment showed its "... unavailable" placeholder, but nothing ever told the
// server, so the Edit Wheel's broken-media pill (GET .../broken-media/) stayed
// empty -- the nightly re-scan that would find block media is not scheduled
// on any environment. Blocks now report their own confirmed load failure,
// tagged with the wheel and the open segment, the same way createPie already
// reports a broken Segment Fill. The server re-checks the url before it
// records anything.
import { createContext, useCallback, useContext } from "react";
import * as ReactRedux from "react-redux";
import { reportBrokenMediaOnce } from "../../../../utils/brokenMediaReport";
import {
  getSelectedSegment,
  getWheelId,
} from "../../../../redux/selectors/segmentBuilderSelectors";

// block_id is a 64-char slot key on the server; a block's own craft node id is
// not reachable from these shared renderers, so the url keys the slot (two
// broken images in one segment stay two rows).
export function blockIdForUrl(url) {
  let h = 0;
  const s = String(url);
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return `url:${(h >>> 0).toString(16)}`;
}

// A renderer mounted without a redux Provider (or with react-redux stubbed)
// just never reports.
const NO_STORE = createContext(null);

/** kind: "image_block" | "media_block" (server BrokenMedia kinds). */
export function useReportBrokenBlockMedia(kind) {
  const redux = useContext(ReactRedux.ReactReduxContext || NO_STORE);
  return useCallback(
    (url) => {
      if (!url || typeof url !== "string" || url.startsWith("blob:")) return;
      let state;
      try {
        state = redux?.store?.getState?.();
      } catch {
        return;
      }
      if (!state) return;
      let wheelId;
      let segmentId;
      try {
        wheelId = getWheelId(state);
        segmentId = getSelectedSegment(state)?.id;
      } catch {
        return;
      }
      // Only a SAVED wheel + segment is a slot the server can match.
      if (wheelId == null || segmentId == null) return;
      if (typeof segmentId === "string" && !/^\d+$/.test(segmentId)) return;
      reportBrokenMediaOnce({
        wheelId,
        kind,
        segmentId,
        blockId: blockIdForUrl(url),
        url,
      });
    },
    [redux, kind]
  );
}

export default useReportBrokenBlockMedia;
